import { motion } from "framer-motion";
import { ArrowRight, Check, Clock, MapPin } from "lucide-react";

export default function Hero() {
  return (
    <section
      className="relative overflow-hidden pt-32 md:pt-40 pb-20 md:pb-32 md-noise"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 md-grid-bg pointer-events-none" />
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#0066FF] blur-[120px]" />
        <div className="absolute top-40 -left-24 h-72 w-72 rounded-full bg-[#00E5FF] blur-[140px] opacity-30" />
      </div>

      <div className="md-container relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <span className="md-eyebrow" data-testid="hero-eyebrow">
            <span className="h-1.5 w-1.5 rounded-full bg-[#00E5FF]" />
            Ammattimaiset verkkosivut yritykselle
          </span>

          <h1
            className="mt-6 font-display text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-white leading-[1.02]"
            data-testid="hero-title"
          >
            Lisää kauppaa.<br />
            <span className="text-white/60">Vähemmän</span> <span className="relative inline-block">
              <span className="relative z-10 text-white">vaivaa.</span>
              <span className="absolute inset-x-0 bottom-1 h-3 bg-[#0066FF]/50 -z-0 blur-sm" />
            </span>
          </h1>

          <p
            className="mt-6 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed"
            data-testid="hero-subtitle"
          >
            MyyntiDrive rakentaa yrityksellesi ammattimaiset verkkosivut alk. 150 € + alv 25,5 % – näet mallisivut ennen kuin maksat euroakaan.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#yhteys"
              className="md-btn-primary text-base"
              data-testid="hero-cta-primary"
              data-track="hero-primary"
            >
              Varaa maksuton kartoituspuhelu <ArrowRight size={18} />
            </a>
            <a
              href="#palvelut"
              className="md-btn-secondary text-base"
              data-testid="hero-cta-secondary"
              data-track="hero-secondary"
            >
              Katso hinnastot
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/60" data-testid="hero-trust-bar">
            <span className="inline-flex items-center gap-2"><Clock size={14} className="text-[#00E5FF]" /> Vastaus 24 h sisällä</span>
            <span className="inline-flex items-center gap-2"><Check size={14} className="text-[#00E5FF]" /> Kiinteä kuukausihinta</span>
            <span className="inline-flex items-center gap-2"><MapPin size={14} className="text-[#00E5FF]" /> Paikallinen kumppani</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6"
        >
          {[
            { k: "24 h", v: "Vastausaika" },
            { k: "150 €", v: "Verkkosivut alk." },
            { k: "1–2 vk", v: "Sivut valmiina" },
            { k: "0 €", v: "Mallisivut ennen ostoa" },
          ].map((s) => (
            <div key={s.v} className="md-card p-5 md:p-6" data-testid={`hero-stat-${s.v.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="font-display text-2xl md:text-3xl font-bold text-white">{s.k}</div>
              <div className="text-xs md:text-sm text-white/50 mt-1">{s.v}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
